import { KButton } from "@kyburz/kdesign-system";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router";
import { RootStateInterface } from "../../../interfaces/ReduxInterface";
import { setAlert } from "../../../redux/actions/actions";
import { updateReportConfig } from "../../../apiCalls/admin/report_configs";
import { useStyles } from "../styles";
import useSetState from "../../../hooks/useTypedSetState";
import BaseLayout from "../../../components/layouts/BaseLayout";
import CompaniesTab from "../../vehicleTemplates/components/tabs/CompaniesTab";
import JSONEditor from "../../../components/JSONEditor/JSONEditor";

const EditReportConfig = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const configToEdit = useSelector(
    (state: RootStateInterface) => state?.reportsConfig?.configToEdit,
  );

  const match = useRouteMatch({
    path: "/config/report_configs/edit/:configId/:tab",
    strict: true,
    sensitive: true,
  });

  const { configId, tab } = match?.params as any;

  const [{ activeTab, config }, setState] = useSetState({
    activeTab: tab,
    config: configToEdit
      ? {
          ...configToEdit,
        }
      : null,
  });

  useEffect(() => {
    setState({ activeTab: tab });
  }, [setState, tab]);

  const handleTabClick = (_, newValue) => {
    history.push(`/config/report_configs/edit/${configId}/${newValue}`);
  };

  useEffect(() => {
    setState({ activeTab: tab });
  }, [configId]);

  const goBack = () => {
    history.push("/config/report_configs");
  };

  const onSave = async () => {
    try {
      if (config)
        await updateReportConfig({
          ...config,
          _id: configId,
        });
      dispatch(
        setAlert(`Report config ${configId} successfully updated.`, "success"),
      );
      goBack();
    } catch (e) {
      dispatch(setAlert(e.message, "error"));
    }
  };

  const onJsonChange = (json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    setState({ config: JSON.parse(json) });
  };

  return (
    <BaseLayout
      title="Edit Reports Config"
      handleArrowClick={goBack}
      activeTab={activeTab}
      tabs={[
        { label: "Template Editor", value: "editor" },
        { label: "Companies", value: "companies" },
      ]}
      handleTabChange={handleTabClick}
      mainClassname={classes.layout}
    >
      <div className={classes.main}>
        {config && (
          <Switch>
            <Route path="/config/report_configs/edit/:configId/editor" exact>
              <JSONEditor value={config} jsonChanged={onJsonChange} />
            </Route>
            <Route path="/config/report_configs/edit/:configId/companies">
              <CompaniesTab
                title={`Report config: ${config.name}`}
                selectedCompanies={config.companies}
                onCompaniesChange={(companies) =>
                  setState({ config: { ...config, companies } })
                }
              />
            </Route>
            <Redirect to="/config/report_configs/edit/:configId/editor" />
          </Switch>
        )}
      </div>

      <footer className={classes.buttons}>
        <KButton children="Cancel" theme="secondary" onClick={goBack} />

        <KButton children="Save and close" onClick={onSave} />
      </footer>
    </BaseLayout>
  );
};

export default EditReportConfig;
